import globals from "@lvt/globals";
import { DateTime } from "luxon";


const root = globals.userdashboard.proxyUrl;

export const routes = {
    getLiveUnitMetaData: (liveUnitId: number): string => {
        return `${root}/api/archive/live_units/${liveUnitId}/nav_meta`;
    },
    getArchiveCabinetMetaData: (archiveCabinetId: number): string => {
        return `${root}/api/archive/archive_cabinets/${archiveCabinetId}/nav_meta`;
    },
    getCameraOrCabinetMetadata: (): string => {
        return `${root}/api/archive/camera_metadata`;
    },
    getPresetImages: (presetId: number, startTime: DateTime, endTime: DateTime): string => {
        return `${root}/api/archive/preset/${presetId}/images/${encodeURIComponent(
            startTime.toUTC().toISO(),
        )}/${encodeURIComponent(endTime.toUTC().toISO())}`;
    },
    getPresetsImages: (): string => {
        return `${root}/api/archive/presets_images`;
    },
    retrieveVideo: (cameraId: number) => {
        return `${root}/api/cameras/archive/${cameraId}`;
    },
    getLiveUnitMetaDataLanding: (liveUnitId: number): string => {
        return `${root}/api/vms/live_units/${liveUnitId}/meta`;
    },
    getLiveUnitInfo: (liveUnitId: number): string => {
        return `${root}/api/vms/live_unit_info/${liveUnitId}`;
    },
    getArchiveCabinetInfo: (archiveCabinetId: number): string => {
        return `${root}/api/vms/archive_cabinets/${archiveCabinetId}`;
    },
    postUserFeedback: (): string => {
        return `${root}/api/user_feedback`;
    },
    getPresignedUrl: (presetId: number): string => {
        return `${root}/api/archive/get_latest_preset_image_presigned_url/${presetId}`;
    },
    postResolveAlert: (alertId: string): string => {
        return `${root}/api/alerts/${alertId}/resolve`;
    },
    getAlert: (alertId: string): string => {
        return `${root}/api/alerts/${alertId}`;
    },
    getAlerts: (): string => {
        return `${root}/api/alerts`;
    },
};
